import { api } from './api'

const apiVersion = 'v2'

export const rateTablesApi = api
    .enhanceEndpoints({
        addTagTypes: ['RateTables'],
    })
    .injectEndpoints({
        endpoints: (builder) => ({
            getRateTables: builder.query({
                query: ({ organisationId }) => ({
                    url: `/${apiVersion}/organisation/${organisationId}/rate-tables`,
                }),
                transformResponse: (response) => {
                    delete response.$type

                    return response
                },
                providesTags: (result, _error, _arg) =>
                    result
                        ? [
                              { type: 'RateTables', id: 'LIST' },
                              ...(Object.values(result).map(({ rateTableId }) => ({
                                  type: 'RateTables',
                                  id: rateTableId,
                              })) ?? []),
                          ]
                        : [{ type: 'RateTables', id: 'LIST' }],
            }),

            getRateTable: builder.query({
                query: ({ organisationId, rateTableId }) => ({
                    url: `/${apiVersion}/organisation/${organisationId}/rate-tables/${rateTableId}`,
                }),
                providesTags: (result, _error, arg) => [
                    { type: 'RateTables', id: arg.rateTableId },
                    { type: 'Rates', id: 'LIST' },
                    ...(result.rates.map(({ rateId }) => ({ type: 'Rates', id: rateId })) ?? []),
                ],
            }),
        }),
    })

export const { useGetRateTableQuery, useGetRateTablesQuery, useLazyGetRateTableQuery, useLazyGetRateTablesQuery } =
    rateTablesApi
